/*
 * Potzillas — Firma / IČO / DIČ v košíku → cart attributes (Fakturoid)
 * Formulář ukládá attributes[firma/ico/dic]; přihlášenému s metafieldy se
 * hodnoty propíšou do cart attributes automaticky (bez zadávání).
 */
(function () {
  'use strict';

  function postAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
      // keepalive: request přežije i případnou navigaci (např. zavření draweru).
      // Hlavní pojistka pro checkout je ale form= na inputech (odešle se synchronně).
      keepalive: true,
    }).catch(function () {});
  }

  if (!customElements.get('company-details')) {
    customElements.define(
      'company-details',
      class extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;
          var self = this;
          this.querySelectorAll('input').forEach(function (input) {
            input.addEventListener('change', function () {
              var attrs = {};
              self.querySelectorAll('input').forEach(function (i) {
                var key = i.name.replace('attributes[', '').replace(']', '');
                attrs[key] = i.value;
              });
              postAttributes(attrs);
            });
          });
        }
      }
    );
  }

  // Přihlášený s metafieldy → jednorázově propsat do cart attributes.
  function syncSaved() {
    var el = document.querySelector('[data-cart-company-auto]');
    if (!el || el._synced) return;
    el._synced = true;
    postAttributes({
      firma: el.dataset.firma || '',
      ico: el.dataset.ico || '',
      dic: el.dataset.dic || '',
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncSaved);
  } else {
    syncSaved();
  }
})();
